export default __webpack_public_path__ + "static/media/video.ada2e233.mp4";